"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject12ToJSON = exports.InlineObject12FromJSONTyped = exports.InlineObject12FromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineObject12FromJSON(json) {
    return InlineObject12FromJSONTyped(json, false);
}
exports.InlineObject12FromJSON = InlineObject12FromJSON;
function InlineObject12FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'parent': !(0, runtime_1.exists)(json, 'parent') ? undefined : json['parent'],
        'sortOrder': !(0, runtime_1.exists)(json, 'sortOrder') ? undefined : json['sortOrder'],
        'isEnabled': !(0, runtime_1.exists)(json, 'isEnabled') ? undefined : json['isEnabled'],
    };
}
exports.InlineObject12FromJSONTyped = InlineObject12FromJSONTyped;
function InlineObject12ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'parent': value.parent,
        'sortOrder': value.sortOrder,
        'isEnabled': value.isEnabled,
    };
}
exports.InlineObject12ToJSON = InlineObject12ToJSON;
